import type { IAsset } from '../providers';
import { formatFileSize, formatDate } from '../utils';
import { ZprAccordion, ZprAccordionPanel } from '@zpr-stencil';

export interface AssetInfoAccordionProps {
  asset: IAsset;
  hideAuthor?: boolean;
}

export const AssetInfoAccordion = ({
  asset,
  hideAuthor = false,
}: AssetInfoAccordionProps) => {
  const metadata = asset.getMetadata();
  const fileSize = (metadata.size as number) || 0;
  const licence = (metadata.licence as string) || '';
  const licenceUrl = (metadata.licenceUrl as string) || '';
  const source = (metadata.source as string) || '';
  const date = metadata.date ? new Date(metadata.date) : null;
  const binnedAt = metadata.binnedAt ? new Date(metadata.binnedAt as string | number) : null;
  const author = (metadata.uploadedBy as string) || '';
  // const labels = Array.isArray(metadata.labels) ? metadata.labels : [];

  return (
    <ZprAccordion className="no-background">
      <ZprAccordionPanel isOpen={true}>
        <span slot="accordion-header">File info</span>
        <div slot="accordion-body">

          {/* File Size */}
          <div className="asset-detail-panel__section">
            <label className="asset-detail-panel__label">File size</label>
            <div className="asset-detail-panel__value">{formatFileSize(fileSize)}</div>
          </div>

          {licence && (
            <div className="asset-detail-panel__section">
              <label className="asset-detail-panel__label">Licence</label>
              <div className="asset-detail-panel__value">
                {licenceUrl ? <a href={licenceUrl} target="_blank" rel="noopener noreferrer">{licence}</a> : licence}
              </div>
            </div>
          )}

          {source && (
            <div className="asset-detail-panel__section">
              <label className="asset-detail-panel__label">Source</label>
              <div className="asset-detail-panel__value">{source}</div>
            </div>
          )}

          {/* Upload Date */}
          {date && (
            <div className="asset-detail-panel__section">
              <label className="asset-detail-panel__label">Date added</label>
              <div className="asset-detail-panel__value">{formatDate(date)}</div>
            </div>
          )}

          {/* Binned Date */}
          {binnedAt && (
            <div className="asset-detail-panel__section">
              <label className="asset-detail-panel__label">Binned at</label>
              <div className="asset-detail-panel__value">{formatDate(binnedAt)}</div>
            </div>
          )}

          {/* Author */}
          {author && !hideAuthor && (
            <div className="asset-detail-panel__section">
              <label className="asset-detail-panel__label">Author</label>
              <div className="asset-detail-panel__value">{author}</div>
            </div>
          )}
        </div>
      </ZprAccordionPanel>
    </ZprAccordion>
  );
};
